import CurrentPackage from './CurrentPackage';

export default CurrentPackage;
